import { render, staticRenderFns } from "./EditImgReview.vue?vue&type=template&id=3f6bfa9e&"
import script from "./EditImgReview.vue?vue&type=script&lang=js&"
export * from "./EditImgReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports